module.exports = __webpack_public_path__ + "static/media/extend.590b1bf1.png";